import { createFileRoute } from '@tanstack/react-router';
import { ReportFollowupPage } from '@/features/people/public/report-followup-page';

export const Route = createFileRoute('/_public/r/$code')({ component: FollowupRoute });

function FollowupRoute() {
  const { code } = Route.useParams();
  return <ReportFollowupPage code={code} />;
}
